import { render, staticRenderFns } from "./TwoFactorModal.vue?vue&type=template&id=a3237e80&scoped=true&"
import script from "./TwoFactorModal.vue?vue&type=script&lang=js&"
export * from "./TwoFactorModal.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorModal.vue?vue&type=style&index=0&id=a3237e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3237e80",
  null
  
)

export default component.exports